import React from 'react';
import type { ToastContextT } from '@/types/Toast';

export const ToastContext = React.createContext<ToastContextT>({
  toggleToast: () => {},
});
